import { useQuery } from '@tanstack/react-query';
import supabase from 'sdk/api';

type AvailableTimeSlotsParams = {
  date: string | null; // date of the appointment 'YYYY-MM-DD'
  team_member_id: string;
  service_id: string;
  granularity?: number; // Amount of minutes to granulate the timeslots i.e 15 mins - 15 minutes
  salon_id: string | number;
};

type TimeSlot = {
  start: string;
  end: string;
};

type AvailableTimeSlotsResponse = {
  slots: TimeSlot[];
};

const fetchAvailableTimeSlots = async (
  params: AvailableTimeSlotsParams,
): Promise<AvailableTimeSlotsResponse> => {
  console.log('📞 Calling Edge Function with params:', params);

  // Return empty slots if required params are missing or 'random'
  if (!params.date || !params.team_member_id || !params.service_id || !params.salon_id || params.team_member_id === 'random') {
    console.warn('⚠️ Missing or invalid required params (teamId: ' + params.team_member_id + '), returning empty slots');
    return { slots: [] };
  }

  const requestBody = {
    date: params.date,
    team_member_id: params.team_member_id,
    service_id: params.service_id,
    granularity: params.granularity || 30,
    salon_id: Number(params.salon_id),
  };

  console.log('📤 Request body:', requestBody);

  const { data, error } = await supabase.functions.invoke('get-available-time-slots', {
    body: requestBody,
  });

  if (error) {
    console.error('❌ Edge function error:', error);
    throw new Error(`Failed to fetch available time slots: ${error.message}`);
  }

  console.log('✅ Edge function response:', data);
  return data || { slots: [] };
};

export default function useGetAvailableTimeSlots(params: AvailableTimeSlotsParams) {
  return useQuery({
    queryKey: [
      'availableTimeSlots',
      params.date,
      params.team_member_id,
      params.service_id,
      params.salon_id,
    ],
    queryFn: () => fetchAvailableTimeSlots(params),
    staleTime: 0,
    enabled: !!params.date && !!params.team_member_id && !!params.service_id && !!params.salon_id,
  });
}
